import React from 'react';

import { Button, ButtonProps } from '@mui/material';

export const CancelButton: React.FC<ButtonProps> = ({
	children,
	sx,
	...props
}) => {
	return (
		<Button
			variant='outlined'
			fullWidth
			size='large'
			sx={{
				color: 'error.main',
				borderColor: 'error.main',
				fontWeight: 'bold',
				'&:hover': {
					borderColor: 'error.main',
					backgroundColor: '#f5d0d0',
				},
				...sx,
			}}
			{...props}
		>
			{children}
		</Button>
	);
};
